import { GroupBase, OptionProps, components } from 'react-select';

import { FlexBox } from '../../../layout';
import * as Colors from '../../../constants/Colors';
import { InlineText } from '../../../typography/InlineText';

type CustomOptionProps<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = OptionProps<Option, IsMulti, Group>;

export const CustomOption = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    children,
    ...props
}: CustomOptionProps<Option, IsMulti, Group>) => (
    <components.Option {...props}>
        {props.isMulti ? (
            <FlexBox
                flexDirection="column"
                justifyContent="center"
                padding="8px 12px"
                minWidth="60px"
                marginLeft="5px"
                cursor="pointer"
                border={`solid 1px ${Colors.blue50}`}
                backgroundColor={Colors.blue50}
                borderRadius="4px"
            >
                <InlineText fontSize="14px" fontWeight="600">
                    {children}
                </InlineText>
            </FlexBox>
        ) : (
            children
        )}
    </components.Option>
);
